import { closeTimesheetPostingModal } from '../State/timesheetPostingModal'

export default () => (dispatch) => {

  dispatch(closeTimesheetPostingModal())
  
}
